/*============================================================================
  Collection / quick-add cart: Ajax add without modifying ajaxify.js.
  ajaxify only binds #addToCartForm; these forms use class collection-quick-add-form.
==============================================================================*/
(function($) {
  if (typeof $ === 'undefined' || typeof Shopify === 'undefined') return;

  var moneyFmt = typeof window.moneyFormat !== 'undefined' ? window.moneyFormat : '${{amount}}';
  var toastHideTimer;

  function pulseCartBadge() {
    var $counts = $('.cart-count');
    $counts.addClass('cart-count--pulse');
    setTimeout(function() {
      $counts.removeClass('cart-count--pulse');
    }, 600);
  }

  function showCollectionToast(message) {
    var $toast = $('#collectionCartToast');
    if (!$toast.length) {
      $('body').append(
        '<div id="collectionCartToast" class="collection-cart-toast" role="status" aria-live="polite" aria-atomic="true" hidden></div>'
      );
      $toast = $('#collectionCartToast');
    }
    clearTimeout(toastHideTimer);
    $toast.removeAttr('hidden').text(message || 'Added to cart').addClass('is-visible');
    toastHideTimer = setTimeout(function() {
      $toast.removeClass('is-visible').attr('hidden', 'hidden').empty();
    }, 3000);
  }

  function scheduleButtonRevert($btn) {
    var prev = $btn.data('collection-atc-revert-timer');
    if (prev) clearTimeout(prev);
    var original = $btn.data('collection-atc-original');
    var timer = setTimeout(function() {
      $btn.removeClass('is-added');
      if (original) {
        $btn.html(original);
      }
      $btn.removeData('collection-atc-revert-timer');
    }, 2500);
    $btn.data('collection-atc-revert-timer', timer);
  }

  function updateCartCountUi(cart) {
    $('.cart-count').each(function() {
      $(this).html(cart.item_count).toggleClass('hidden-count', cart.item_count === 0);
    });
    if ($('.cart-cost').length && Shopify.formatMoney) {
      $('.cart-cost').html(Shopify.formatMoney(cart.total_price, moneyFmt));
    }
  }

  /**
   * Mirrors ajaxify cartTemplate + adjustCart after fragment loads (useCartTemplate: true).
   */
  function themeCreateQtySelectors($cartContainer) {
    if (typeof Handlebars === 'undefined' || !$('#ajaxifyQty').length) return;

    $('input[type="number"]', $cartContainer).each(function() {
      var el = $(this);
      var currentQty = el.val();
      var itemAdd = parseInt(currentQty, 10) + 1;
      var itemMinus = parseInt(currentQty, 10) - 1;
      var itemQty = currentQty + ' x';

      var source = $('#ajaxifyQty').html();
      var template = Handlebars.compile(source);
      var data = {
        id: el.data('id'),
        itemQty: itemQty,
        itemAdd: itemAdd,
        itemMinus: itemMinus
      };

      el.after(template(data)).remove();
    });

    $('a[href^="/cart/change"]', $cartContainer).each(function() {
      $(this).addClass('ajaxifyCart--remove');
    });
  }

  function themeAdjustCartBindings($cartRoot) {
    var qtyAdjust = $cartRoot.find('.ajaxifyCart--qty span');

    qtyAdjust.off('click.collectionCartAdd').on('click.collectionCartAdd', function() {
      var el = $(this);
      var id = el.data('id');
      var qtySelector = el.siblings('.ajaxifyCart--num');
      var qty = parseInt(qtySelector.val(), 10);

      if (el.hasClass('ajaxifyCart--add')) {
        qty = qty + 1;
      } else {
        qty = qty - 1;
        if (qty <= 0) qty = 0;
      }

      if (id) {
        themeUpdateLineItem(id, qty, $cartRoot);
      } else {
        qtySelector.val(qty);
      }
    });

    $cartRoot.find('.ajaxifyCart--num').off('change.collectionCartAdd').on('change.collectionCartAdd', function() {
      var el = $(this);
      var id = el.data('id');
      var qty = el.val();

      if ((parseFloat(qty) === parseInt(qty, 10)) && !isNaN(qty)) {
        /* ok */
      } else {
        el.val(1);
        return;
      }

      if (id) {
        themeUpdateLineItem(id, qty, $cartRoot);
      }
    });

    $cartRoot.find('.ajaxifyCart--remove').off('click.collectionCartAdd').on('click.collectionCartAdd', function(e) {
      var el = $(this);
      var id = el.data('id') || null;
      if (!id) return;
      e.preventDefault();
      themeUpdateLineItem(id, 0, $cartRoot);
    });

    var noteArea = $cartRoot.find('textarea[name="note"]');
    noteArea.off('change.collectionCartAdd').on('change.collectionCartAdd', function() {
      var newNote = $(this).val();
      if (typeof Shopify.updateCartNote === 'function') {
        Shopify.updateCartNote(newNote, function() {});
      }
    });
  }

  function themeUpdateLineItem(id, qty, $cartRoot) {
    var rowSelector = '.cart-row[data-id="' + id + '"]';
    var row = $cartRoot.find(rowSelector).addClass('ajaxifyCart--is-loading');

    if (qty === 0) {
      row.addClass('is-removed');
    }

    setTimeout(function() {
      Shopify.changeItem(id, qty, function(cart) {
        updateCartCountUi(cart);
        refreshAjaxCartMarkup();
      });
    }, 250);
  }

  function refreshAjaxCartMarkup() {
    var $cart = $('#ajaxifyCart');
    if (!$cart.length) return;

    $cart.load('/cart form[action="/cart"]', function(response, status) {
      if (status === 'error') return;
      themeCreateQtySelectors($cart);
      themeAdjustCartBindings($cart);
    });
  }

  $(document).on('submit', 'form.collection-quick-add-form', function(e) {
    e.preventDefault();

    var form = this;
    var $form = $(form);
    var $btn = $form.find('button[type="submit"], input[type="submit"]');

    $form.next('.qty-error').remove();

    var revertTimer = $btn.data('collection-atc-revert-timer');
    if (revertTimer) clearTimeout(revertTimer);

    if ($btn.hasClass('is-added')) {
      var orig = $btn.data('collection-atc-original');
      if (orig) {
        $btn.html(orig);
      }
      $btn.removeClass('is-added');
    }

    if (!$btn.data('collection-atc-original')) {
      $btn.data('collection-atc-original', $btn.html());
    }

    $btn.removeClass('is-added').addClass('is-adding');

    Shopify.addItemFromForm(form, function(/* line_item, f */) {
      $btn.removeClass('is-adding').addClass('is-added');
      $btn.html('<span class="icon icon-cart"></span> Added!');
      scheduleButtonRevert($btn);

      Shopify.getCart(function(cart) {
        updateCartCountUi(cart);
        pulseCartBadge();
        showCollectionToast('Added to cart');

        if ($('#ajaxifyCart').length) {
          refreshAjaxCartMarkup();
        }

        $(document).trigger('collectionQuickAdd:added', [form]);
      });
    }, function(xhr) {
      $btn.removeClass('is-adding');
      var original = $btn.data('collection-atc-original');
      if (original) {
        $btn.html(original);
      }
      var data;
      try {
        data = JSON.parse(xhr.responseText);
      } catch (err) {
        return;
      }
      if (data.message && data.status === 422) {
        $form.after('<div class="errors qty-error">' + data.description + '</div>');
      }
    });
  });

})(jQuery);
